export const createMessagesRequests = (client) => ({
    listMessages: async (params) => {
        const { data, meta, links } = await client.api.get("messages", {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map